import React, { Fragment, FunctionComponent, ReactNode } from 'react';

import { useEthers } from '@usedapp/core';

import Button from '@bitcoin-portal/verse-web-components/dist/Button';
import H3 from '@bitcoin-portal/verse-web-components/dist/H3';
import Line from '@bitcoin-portal/verse-web-components/dist/Icons/Line';
import Search from '@bitcoin-portal/verse-web-components/dist/Icons/Search';
import Link from '@bitcoin-portal/verse-web-components/dist/Link';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

import { chainIdToExplorer } from '../../helpers';

import { Step } from '../Step';
import { AnimationWrapper, Header, ViewWrapper } from './styled';

interface TxErrorProps {
  title: string;
  loaderAnimation: ReactNode;
  steps: StepProps[];
  transactionHash: string;
  reset: () => void;
  destinationChain?: number;
}

export const TxError: FunctionComponent<TxErrorProps> = ({
  title,
  loaderAnimation,
  steps,
  transactionHash,
  reset,
  destinationChain,
}) => {
  const { chainId } = useEthers();
  const explorer = chainIdToExplorer(destinationChain || chainId);

  return (
    <ViewWrapper>
      <Header>
        <H3 style={{ padding: '16px 0 8px' }}>{title}</H3>
      </Header>
      <AnimationWrapper>{loaderAnimation}</AnimationWrapper>
      <div style={{ marginTop: 40, marginBottom: 34 }}>
        {steps.map((step, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={`${step.title}-${idx}`}>
            {idx !== 0 && (
              <Line color={colors.shade30} style={{ padding: '12px 0' }} />
            )}
            <Step {...step} />
          </Fragment>
        ))}
      </div>
      <Button fullWidth onClick={reset}>
        Try Again
      </Button>
      {transactionHash && (
        <Link
          href={`https://${explorer}/tx/${transactionHash}`}
          newTab
          style={{
            marginTop: '27px',
            display: 'flex',
            justifyContent: 'center',
            fontSize: 14,
          }}
        >
          <Search
            size={13}
            color={colors.verseBlue}
            style={{ marginRight: 7, alignSelf: 'center' }}
          />
          View Transaction
        </Link>
      )}
    </ViewWrapper>
  );
};

export default TxError;
